import { createSlice } from '@reduxjs/toolkit';

interface Message {
	id: string;
	text: string;
	sender: 'user' | 'bot';
	timestamp: Date;
}

export interface MessagesState {
	threadId: string | null;
	messages: Message[];
}

const initialState: MessagesState = {
	threadId: null,
	messages: []
};

export const messagesSlice = createSlice({
	name: 'messages',
	initialState,
	reducers: {
		setThreadId: (state, { payload }) => {
			state.threadId = payload;
		},
		setMessages: (state, { payload }) => {
			state.messages = payload;
		},
		addMessage: (state, { payload }) => {
			state.messages.push(payload);
		},
		clearMessages: state => {
			state.messages = [];
		},
		updateLastBotMessageOrAdd: (state, { payload }: { payload: string }) => {
			const lastMessage = state.messages[state.messages.length - 1];
			if (lastMessage && lastMessage.sender === 'bot') {
				state.messages[state.messages.length - 1] = {
					...lastMessage,
					text: payload,
					timestamp: new Date()
				};
			} else {
				state.messages.push({
					id: Date.now().toString(),
					text: payload,
					sender: 'bot',
					timestamp: new Date()
				});
			}
		}
	}
});

const { reducer } = messagesSlice;
export const { setThreadId, setMessages, addMessage, clearMessages, updateLastBotMessageOrAdd } = messagesSlice.actions;

export const messagesReducer = reducer;
